import React, { useRef, useEffect, useState } from "react";

import { OuterContainer, InnerContainer, List } from "./FooterStyles";
import Preview from "./Preview";

const Footer = ({ dataList, activeItem, setActiveItem }) => {
  const listRef = useRef();
  const itemRef = useRef();
  const prevActiveItem = useRef(0);

  const [scrollPos, setScrollPos] = useState(0);

  const totalItem = dataList.length;

  useEffect(() => {
    const margin = 4;

    const itemInRow = Math.floor(
      listRef.current?.offsetWidth / (itemRef.current?.offsetWidth + margin),
    );

    const listScrollWidth = listRef.current?.scrollWidth;
    const listWidth = listRef.current?.offsetWidth;

    const itemWidth = itemRef.current?.offsetWidth;

    const maxScrollPos =
      listScrollWidth - (itemInRow - 2) * (itemWidth + margin);

    const handleSetScrollPos = (value) => {
      if (Math.sign(value) * value <= maxScrollPos && value <= 0) {
        setScrollPos(value);
      }
    };

    if (listScrollWidth > listWidth) {
      if (totalItem < itemInRow * 2) {
        if (activeItem < itemInRow - 1) {
          handleSetScrollPos(0);
        } else {
          handleSetScrollPos(-maxScrollPos);
        }
      } else {
        let position;

        if (activeItem < itemInRow - 1) {
          position = 0;
        } else if (activeItem > totalItem + 2 - itemInRow) {
          position = maxScrollPos;
        } else {
          position =
            activeItem * (itemWidth + 4) - listRef.current?.offsetWidth / 2;
        }

        handleSetScrollPos(-position);
      }
    }

    prevActiveItem.current = activeItem;
  }, [activeItem, totalItem]);

  const renderImage = () => {
    return dataList?.map((item, index) => (
      <Preview
        key={item.id}
        itemRef={itemRef}
        data={item}
        setActiveItem={setActiveItem}
        active={activeItem === index}
        index={index}
      />
    ));
  };

  if (!dataList) {
    return null;
  }

  return (
    <OuterContainer>
      <div>
        <InnerContainer>
          <List scrollPos={scrollPos} ref={listRef}>
            {renderImage()}
          </List>
        </InnerContainer>
      </div>
    </OuterContainer>
  );
};

export default Footer;
